export interface SocialLink {
  label: string;
  url: string;
  username?: string;
}

export interface ContactGuarantee {
  title: string;
  description: string;
}

export interface ContactInfo {
  name: string;
  role: string;
  tagline: string;
  email: string;
  phone: {
    raw: string;
    formatted: string;
    whatsappUrl: string;
  };
  pIva: string;
  location: string;
  availability: string;
  responseTime: string;
  socials: {
    linkedin: SocialLink;
    instagram: SocialLink;
    whatsapp: SocialLink;
    github?: SocialLink;
  };
  guarantees: ContactGuarantee[];
}

export const CONTACT_INFO: ContactInfo = {
  name: 'Matteo Petix',
  role: 'Strategia AI, Sviluppo Software & Project Management',
  tagline: 'Consulenza AI e IT, project management e sviluppo software su misura. Trasformiamo idee e visioni aziendali in prodotti digitali intelligenti, performanti e scalabili.',
  email: 'info@matteopetix.com',
  phone: {
    raw: '393513422588',
    formatted: '+39 351 342 2588',
    whatsappUrl: 'https://wa.me/393513422588',
  },
  pIva: '17963251008',
  location: 'Roma, Italia',
  availability: 'Aperto a nuovi progetti e consulenze',
  responseTime: 'Risposta garantita entro 24 ore',
  socials: {
    linkedin: {
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/matteopetix/',
      username: 'matteopetix',
    },
    instagram: {
      label: 'Instagram',
      url: 'https://www.instagram.com/matteopetixit/',
      username: '@matteopetixIT',
    },
    whatsapp: {
      label: 'WhatsApp',
      url: 'https://wa.me/393513422588',
      username: '+39 351 342 2588',
    },
  },
  guarantees: [
    { title: 'Risposta entro 24h', description: 'Feedback tempestivo e professionale' },
    { title: 'NDA & Riservatezza', description: 'Accordo di riservatezza su richiesta' },
    { title: 'Prima consulenza gratuita', description: 'Analisi iniziale dei requisiti' },
  ],
};

export default CONTACT_INFO;
